import { z } from '../utils/zod.js';
import { planCodeSchema } from '../pricing-catalogue.js';
export const ADMIN_USER_STATES = ['REGISTERING', 'READY', 'SUSPENDED', 'ARCHIVED'];
export const adminUserStateSchema = z.enum(ADMIN_USER_STATES);
export const ADMIN_USER_ROLES = ['ADMIN', 'MEMBER', 'GUEST'];
export const adminUserRoleSchema = z.enum(ADMIN_USER_ROLES);
export const ADMIN_SIGNING_STATES = [
    'DRAFT',
    'IN_REVIEW',
    'STARTING',
    'SIGNING',
    'CANCELLED',
    'EXPIRED',
    'COMPLETED',
];
export const adminSigningStateSchema = z.enum(ADMIN_SIGNING_STATES);
export const adminUserCompactSchema = z.object({
    id: z.string().uuid(),
    email: z.string(),
    name: z.string(),
    state: adminUserStateSchema,
    organizationId: z.string().uuid().nullable(),
});
export const adminOrganizationCompactSchema = z.object({
    id: z.string().uuid(),
    name: z.string(),
    country: z.string(),
    planCode: planCodeSchema,
});
export const adminSigningCompactSchema = z.object({
    id: z.string().uuid(),
    name: z.string(),
    state: adminSigningStateSchema,
    organizationId: z.string().uuid(),
    createdAt: z.string().datetime(),
});
